import React from 'react';
import Bone from './Bone';

/** Placeholder for a list screen: toolbar (search + actions), then a table card with header, rows and pagination. */
export default function TableSkeleton({ rows = 10, columns = 5 }) {
    const grid = { gridTemplateColumns: `minmax(0, 2fr) repeat(${Math.max(columns - 1, 0)}, minmax(0, 1fr))` };

    return (
        <div aria-busy="true">
            {/* Toolbar */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
                <Bone className="h-9 w-full sm:w-72 rounded-lg" />
                <div className="flex gap-2">
                    <Bone className="h-9 w-24 rounded-lg" />
                    <Bone className="h-9 w-32 rounded-lg" />
                </div>
            </div>

            <div className="shelf-card overflow-hidden">
                {/* Header */}
                <div className="grid gap-4 items-center px-4 h-11 bg-surface-50 border-b border-surface-100" style={grid}>
                    {Array.from({ length: columns }).map((_, index) => (
                        <Bone key={index} className={`h-3 ${index === 0 ? 'w-24' : 'w-16'} ${index > 0 && index === columns - 1 ? 'justify-self-end' : ''}`} />
                    ))}
                </div>

                {/* Rows */}
                <div className="divide-y divide-surface-100">
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <div key={rowIndex} className="grid gap-4 items-center px-4 h-[52px]" style={grid}>
                            {Array.from({ length: columns }).map((_, colIndex) =>
                                colIndex === 0 ? (
                                    <div key={colIndex} className="flex items-center gap-3 min-w-0">
                                        <Bone className="h-8 w-8 rounded-lg shrink-0" />
                                        <div className="flex-1 min-w-0 space-y-1.5">
                                            <Bone className="h-3.5" style={{ width: `${55 + ((rowIndex * 13) % 35)}%` }} />
                                            <Bone className="h-2.5 w-2/5" />
                                        </div>
                                    </div>
                                ) : (
                                    <Bone
                                        key={colIndex}
                                        className={`h-3.5 ${colIndex === columns - 1 ? 'w-14 justify-self-end' : ''}`}
                                        style={colIndex === columns - 1 ? undefined : { width: `${50 + (((rowIndex + colIndex) * 11) % 40)}%` }}
                                    />
                                )
                            )}
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                <div className="flex items-center justify-between px-4 py-3 border-t border-surface-100">
                    <Bone className="h-3.5 w-28" />
                    <div className="flex gap-1.5">
                        {Array.from({ length: 4 }).map((_, index) => (
                            <Bone key={index} className="h-8 w-8 rounded-lg" />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
